import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, StarIcon } from 'lucide-react';
export function SocialProof() {
  const faqs = [{
    q: '¿Necesito una batidora industrial?',
    a: 'No, las recetas están adaptadas para batido manual o batidoras caseras sencillas.'
  }, {
    q: '¿Cuánto dinero necesito para empezar?',
    a: 'Si tienes harina, azúcar y huevos en casa, ya tienes el 80% de lo necesario para tu primer lote.'
  }, {
    q: '¿Tengo que saber mucho de cocina?',
    a: 'No, el manual explica las técnicas desde cero de forma muy visual y sencilla.'
  }, {
    q: '¿Cómo calculo el precio si el dólar sube?',
    a: 'El manual incluye el "Seguro de Reposición" en la fórmula de costos para proteger tu capital.'
  }, {
    q: '¿El PDF es fácil de leer en el celular?',
    a: 'Sí, está optimizado para consultarlo en la cocina directamente desde tu teléfono.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 px-6 bg-cream-dark" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        {/* Proof Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-amber/10 border-2 border-amber/20 p-8 md:p-10 rounded-3xl mb-20 text-center relative" data-id="element-126">
          <div className="flex justify-center gap-1 mb-6" data-id="element-127">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 text-amber fill-amber" data-id="element-128" />)}
          </div>
          <p className="text-xl md:text-2xl font-serif text-chocolate-dark leading-relaxed italic" data-id="element-129">
            "En menos de 7 días, un lote estándar de 12 porciones de nuestra
            'Torta Húmeda de Chocolate' genera un retorno que cubre el costo de
            este manual y sobra para reinvertir en el siguiente bulto de harina.
            No necesitas cientos de clientes, solo necesitas el sistema correcto
            para que cada venta cuente."
          </p>
        </motion.div>

        {/* FAQ Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-131">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-132">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-warm overflow-hidden" data-id="element-133">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-134">
                  <span className="text-lg font-bold text-chocolate pr-4" data-id="element-135">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-terracotta transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-136" />
                </button>

                <AnimatePresence data-id="element-137">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-138">
                      <div className="px-6 pb-5 text-chocolate/80 text-lg" data-id="element-139">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}